import { cap } from '../../../State'
import { translations } from '../../../translations'
import { COSTO_PER_CONVERSAZIONE } from '../constants'
import { HandledPercentageNora } from '../HandledPercentageNora'
import { InfoTotalPrice } from '../InfoTotalPrice'
import { KpiConversationsCard } from '../KpiConversationsCard'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Griglia KPI: card prezzo totale, (opzionale) card fatturati, percentuale Nora, card conversazioni.
 * @param {Object} props
 * @param {boolean} props.isFatturazione - Se l'utente è in ruolo fatturazione
 * @param {Object} props.totalPriceGeneral - { counter, total }
 * @param {Object} props.totalPriceFatturato - { counter, total } (solo per fatturazione)
 * @param {Object} props.handledPercentage - { perc, totalHandled, totalError, totalConversationsLength }
 * @param {Object} props.data - Dati dashboard (conversations, errorHandled, ecc.)
 * @returns {JSX.Element}
 */
export function StatisticsKpiGrid({
  isFatturazione,
  totalPriceGeneral,
  totalPriceFatturato,
  handledPercentage,
  data
}) {
  return (
    <div className={`ngrid-3 stats-kpi-grid${isFatturazione ? ' stats-kpi-grid--two' : ''}`}>
      <InfoTotalPrice
        totalPriceGeneral={totalPriceGeneral}
        costPerConversation={COSTO_PER_CONVERSAZIONE}
      />

      {isFatturazione && (
        <div className="ncard nkpi-card nkpi-card--green">
          <div className="ncard__head">
            <div
              className="ncard__ico"
              style={{ background: 'var(--success-tint)', color: 'var(--success)' }}
            >
              <i className="pi pi-receipt" style={{ fontSize: 16 }} />
            </div>
            <div>
              <h3 className="ncard__title">{t.totaleFatturatiNelPeriodo}</h3>
            </div>
          </div>
          <div className="ncard__body">
            <div className="nkpi__value" style={{ color: 'var(--success)', fontSize: 36 }}>
              {(totalPriceFatturato?.total || 0).toFixed(2)}€
            </div>
            <div style={{ fontSize: 12.5, color: 'var(--ink-500)', marginTop: 6 }}>
              {t.nConversazioni}{' '}
              <strong style={{ color: 'var(--ink-900)', fontWeight: 600 }}>
                {totalPriceFatturato?.counter || 0}
              </strong>
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 2 }}>
              {t.costoAConversazione} €{COSTO_PER_CONVERSAZIONE?.toFixed(2) || 0}
            </div>
          </div>
        </div>
      )}

      {!isFatturazione && (
        <>
          <HandledPercentageNora handledPercentage={handledPercentage} />
          <KpiConversationsCard
            totalConversations={data?.conversations?.length || 0}
            totalHandled={handledPercentage?.totalHandled || 0}
            totalForwarded={data?.errorHandled?.length || 0}
            totalErrors={handledPercentage?.totalError || 0}
          />
        </>
      )}
    </div>
  )
}
